import {FileUploadDropZone} from "../../components/common/FileUploader/FileUploadDropZone";
import {Footer} from "../../components/modules/Footer/Footer";
import Head from "next/head";
import {Navbar} from "../../components/modules/Navbar/Navbar";
import type {NextPage} from "next";
import RouteNames from "../../Routes/RouteNames";
import {StitchFeatureHero} from "../../components/Features/StitchPictures/StitchFeatureHero";
import {StitchFeatureSection2} from "../../components/Features/StitchPictures/StitchFeatureSection2";
import {StitchFeatureSection3} from "../../components/Features/StitchPictures/StitchFeatureSection3";
import {StitchFeatureSection4} from "../../components/Features/StitchPictures/StitchFeatureSection4";
import {StitchFeatureSection5} from "../../components/Features/StitchPictures/StitchFeatureSection5";
import {StitchFeatureSection6} from "../../components/Features/StitchPictures/StitchFeatureSection6";
import {appColors} from "../../components/common/Colors";
import {useState} from "react";
import Script from "next/script";


const Page: NextPage = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div>
      <Head>
        <title>Photo Joiner - Merge Photos Online For Free</title>
        <meta
          name="description"
          content="A fast online photo joiner tool to merge photos horizontally or vertically. Combine multiple photos, add borders, stickers, text, and more!"
        />
        <link
          rel="canonical"
          href="https://www.photojoiner.com/features/photo-joiner"
        />
        <Script
          src="https://sak.userreport.com/photopix/launcher.js"
          async
          id="userreport-launcher-script"
        ></Script>
      </Head>

      <FileUploadDropZone
        location="web_stitch"
        routeName={RouteNames.collageEditorStitch}
      >
        <Navbar backgroundColor={appColors.siteHeroBg} />

        <StitchFeatureHero
          backgroundColor={appColors.siteHeroBg}
          // imageSrc="/static/photojoiner.com-photo-stitch-sample-1.webp"
          textColor="black"
          circle1Color="#FF7E11"
          circle2Color="#FFEAD8ea"
        />

        <StitchFeatureSection2
          backgroundColor="#FFFFFF"
          circle1Color="#FA4772"
          circle2Color="#FFC3D2"
          imageSrc="/static/photojoiner.com-photo-stitch-sample-2.webp"
          dots1Color="#F8BECC"
          dots2Color="#F54670"
        />
        <StitchFeatureSection3
          imageSrc="/static/photojoiner.com-photo-stitch-sample-3.webp"
          backgroundColor="#F8FAFF"
          shape1Color="#F2994A"
          shape2Color="#FFE6D0"
          dots2Color="#ED9649"
        />

        <StitchFeatureSection4
          backgroundColor="#FFFFFF"
          circle3Color="#46B3A5"
          circle4Color="#B3EBE4"
          dots2Color="#46B0A3"
          imageSrc="/static/photojoiner.com-photo-stitch-sample-4.webp"
        />
        <StitchFeatureSection5 backgroundColor="#F8FAFF" />
        <StitchFeatureSection6
          backgroundColor="#F3F2E9"
          shapeColors={{
            shape1: "#FFC400",
            shape2: "#2E6D92",
            shape3: "#F6D68D",
            shape4: "#FE4773",
            shape5: "#580C82",
            shape6: "#8F30A1",
            shape7: "transparent",
            shape8: "#46B3A5",
          }}
        />
        <Footer
          backgroundColor="#FAFAFA"
          textColor="black"
          titleColor="black"
        />
      </FileUploadDropZone>
    </div>
  );
};

export default Page;
